export default "__VITE_ASSET__DC_7w9Ch__"